import React, { useState, useMemo } from 'react';
import { getCitiesByCountry } from '../data/cities.js';
import { FaTimes, FaMapMarkerAlt } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function CitySelectModal({ open, onClose, onSelect, currentCity, countryCode }) {
  const { t } = useTranslation();
  const [search, setSearch] = useState('');

  // Seçili ülkenin şehirlerini al
  const cities = useMemo(() => {
    return getCitiesByCountry(countryCode) || [];
  }, [countryCode]);

  // Aramaya göre filtrelenmiş şehirler
  const filteredCities = useMemo(() => {
    if (!search.trim()) return cities;
    return cities.filter(city =>
      city.toLowerCase().includes(search.toLowerCase())
    );
  }, [cities, search]);

  // 3 sütuna böl
  const chunkedCities = useMemo(() => {
    const chunks = [];
    for (let i = 0; i < filteredCities.length; i += 3) {
      chunks.push(filteredCities.slice(i, i + 3));
    }
    return chunks;
  }, [filteredCities]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-[95vw] max-w-4xl border border-blue-100 flex flex-col gap-4 animate-fade-in" style={{maxHeight: '85vh'}}>
        <div className="flex justify-between items-center mb-2">
          <div className="text-xl font-bold text-blue-900 flex items-center gap-2">
            <FaMapMarkerAlt className="text-blue-600" />
            {t('Şehir Seçimi')}
          </div>
          <button onClick={onClose} className="text-blue-700 hover:text-blue-900 text-2xl font-bold px-2">&times;</button>
        </div>
        
        <input
          className="w-full px-4 py-3 mb-3 border border-blue-200 rounded-lg focus:ring-2 focus:ring-blue-200 outline-none text-blue-900 bg-blue-50"
          placeholder={t('Şehir adı ara...')}
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoFocus
        />
        
        <div className="flex-1 overflow-y-auto pr-2">
          {chunkedCities.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2">
              {chunkedCities.map((chunk, chunkIndex) => (
                <div key={chunkIndex} className="flex flex-col gap-1">
                  {chunk.map(city => (
                    <button
                      key={city}
                      onClick={() => { onSelect(city); onClose(); }}
                      className={`text-left px-3 py-2 rounded-lg border border-transparent hover:bg-blue-100 transition text-blue-900 ${
                        currentCity === city ? 'bg-blue-100 font-bold border-blue-300' : ''
                      }`}
                    >
                      {city}
                    </button>
                  ))}
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center text-gray-500 py-8">
              {search.trim() ? t('Aradığınız şehir bulunamadı') : t('Bu ülke için şehir verisi bulunamadı')}
            </div>
          )}
        </div>
        
        <div className="text-sm text-gray-500 text-center">
          {t('şehir bulundu', { count: filteredCities.length })}
        </div>
      </div>
    </div>
  );
} 